import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { QuotationRequestModel } from "@model/quotation.model";


@Injectable({
    providedIn: "root",
})
export class CountryApiService {

    constructor(private http: HttpClient) {
    }
    
    GetCountries(): Observable<any> {
        return this.http.get<any>("/country/GetCountries");
    }
}
